const isBlank = value =>
  value === undefined || value === null || String(value).trim() === "";

// Completa los campos vacíos del borrador del huésped con los del servidor,
// sin pisar nada que el huésped haya escrito. Devuelve el mismo objeto si no
// hubo nada para completar (así el llamador evita re-renders).
export const fillBlankFields = (draft, serverPax) => {
  if (!draft || !serverPax) return draft;
  let filled = draft;
  Object.keys(serverPax).forEach(key => {
    if (isBlank(filled[key]) && !isBlank(serverPax[key])) {
      if (filled === draft) filled = { ...draft };
      filled[key] = serverPax[key];
    }
  });
  return filled;
};
